export class ClienteFiltrar {
  public codigo: string;
  public cnpj_cpf: string;
  public nome_fantasia: string;
  public razao_social: string;
  public cidade: string;

  constructor() { }
}
